import styled from 'styled-components';
const CardStyled = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 12px;
  background-color: ${({ theme: { colors } }) => colors.gray100};
  box-shadow: 4px 4px 20px 0px rgba(111, 140, 176, 0.41), -6px -6px 20px 0px #fff,
    2px 2px 4px 0px rgba(114, 142, 171, 0.1);

  ${({ variant, clicked, theme: { colors } }) => {
    switch (variant) {
        case 'outlined':
            return `
            border: 1px solid ${colors.blue300};
            border-left: 0px;
            border-right: 0px;
            border-radius: 0px;
            ${!clicked && `background-color: #E3EDF7`}
            `;
        default:
            return clicked
                ? `box-shadow: 4px 4px 14px 0px #D9D9D9 inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;`
                : ``;
    }
}}
`;
export default CardStyled;
//# sourceMappingURL=styled.js.map